import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import Seo from "../components/Seo";

export default function NotFound() {
  return (
    <div className="max-w-2xl mx-auto px-4 py-32 text-center">
      <Seo title="Page Not Found" description="The page you were looking for could not be found." noindex />
      <p className="section-eyebrow">404</p>
      <h1 className="font-heading text-4xl sm:text-5xl text-[#1a1713]">This page has moved on</h1>
      <p className="text-[#5c5240] mt-5 leading-relaxed">
        The page you're looking for doesn't exist — but 1,300+ pieces of gold and diamond jewelry do.
      </p>
      <div className="flex flex-wrap justify-center gap-4 mt-9">
        <Link to="/shop">
          <Button className="rounded-none bg-[#1a1713] hover:bg-[#3a2f1d] text-[#f3ead2] tracking-[0.2em] uppercase text-xs px-8 py-4 h-auto transition-colors duration-300">Shop All Jewelry</Button>
        </Link>
        <Link to="/collections">
          <Button variant="outline" className="rounded-none border-[#1a1713] text-[#1a1713] hover:bg-[#1a1713] hover:text-[#f3ead2] tracking-[0.2em] uppercase text-xs px-8 py-4 h-auto transition-colors duration-300">Browse Collections</Button>
        </Link>
      </div>
    </div>
  );
}
